import DownloadBanner from './DownloadBanner';
import DownloadSection from './DownloadSection';

function Download() {
  return (
    <div>
      <DownloadBanner />
      <DownloadSection />
    </div>
  );
}

export default Download;